<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Auditoria de Servidor
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Página de auditoria do servidor (mockada para testes).
        </p>
        <p *ngIf="idServidor">
          <strong>ID do Servidor:</strong> {{ idServidor }}
        </p>
        <p *ngIf="idCidade">
          <strong>ID da Cidade:</strong> {{ idCidade }}
        </p>
      </div>
      <div class="col-sm-12 mt-3">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-left"></i> Voltar para Lista de Servidores
        </button>
      </div>
    </div>
  </div>
</div>












